import React, { Component } from "react";
import {
  Container,
  KeyboardView,
  Wrapper,
  ProgressBar,
  Copy
} from "app/NativeComponents/common";
import {
  NewHeader,
  SelectItem,
  InlineButton,
  SmallLabel,
  BottomNavBar,
  ConfirmInlineButton
} from "app/NativeComponents/snippets";

import { connect } from "react-redux";
import {
  getSourceOfTruth,
  popSidePanel,
  numberWithCommas,
  displayIntercom,
  manageSubscription,
  popAllSidePanels,
  renderDate
} from "app/NativeActions";

class PlanDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelLoading: false
    };

    this.resetCustomerInfo = this.resetCustomerInfo.bind(this);
  }

  resetCustomerInfo() {
    this.props.popAllSidePanels();
    this.props.getSourceOfTruth({
      token: this.props.token,
      no_loading: true
    });
  }

  handleBack() {
    this.props.popSidePanel();
  }
  renderSubText(meta_slug) {
    const { source_of_truth } = this.props;
    if (source_of_truth && source_of_truth?.subscription?.products) {
      for (let i = 0; i < source_of_truth?.subscription?.products.length; i++) {
        if (
          source_of_truth?.subscription?.products[i]?.product_slug == meta_slug
        ) {
          if (
            source_of_truth?.subscription?.products[i]?.payment_type == "iap"
          ) {
            return "Purchased Through App Store";
          } else {
            return "Purchased";
          }
        }
      }
    }

    return "";
  }

  startCancellationFlow = () => {
    const { token, source_of_truth } = this.props;
    this.props.manageSubscription({
      token,
      type: "cancel_all_plans",
      stripe_sub_id: source_of_truth?.subscription?.stripe_id,
      no_messaging: false,
      onLoading: () => {
        this.setState({
          cancelLoading: true
        });
      },
      onError: () => {
        this.setState({
          cancelLoading: false
        });
      },
      onSuccess: () => {
        this.setState(
          {
            cancelLoading: false
          },
          () => {
            this.resetCustomerInfo();
          }
        );
      }
    });
  };

  render() {
    const { source_of_truth } = this.props;
    return (
      <Container>
        <NewHeader
          title={"Plan Details"}
          leftButton={{
            icon: "arrow-back",
            onPress: () => this.handleBack()
          }}
        />
        <KeyboardView style={{ flex: 1 }}>
          <SelectItem
            select_type="none"
            noPress={true}
            selected={true}
            renderBottom={
              source_of_truth?.subscription?.metadata &&
              source_of_truth?.subscription?.metadata?.total_number_of_leads !=
                "unlimited"
                ? () => {
                    const current_limit = parseInt(
                      source_of_truth?.subscription?.metadata
                        ?.total_number_of_leads
                    );
                    let count = parseInt(
                      source_of_truth?.current_limits?.total_number_of_leads
                        ?.amount
                    );
                    if (count > current_limit) {
                      count = current_limit;
                    }

                    return (
                      <>
                        <Wrapper
                          style={{
                            paddingRight: 25,
                            paddingLeft: 25,
                            marginTop: -15,
                            paddingBottom: 25
                          }}
                        >
                          <ProgressBar
                            color={this.props.colors.success_color}
                            width={200}
                            progress={
                              parseInt(count) > 0
                                ? parseInt(count) / parseInt(current_limit)
                                : 0
                            }
                          />
                          <Copy style={{ fontSize: 10 }}>
                            {numberWithCommas(count)} /{" "}
                            {numberWithCommas(current_limit)}{" "}
                            {"Total managed leads with live updates"}
                          </Copy>
                        </Wrapper>
                        {source_of_truth?.subscription?.cancel_at_period_end ? (
                          <Wrapper>
                            <SmallLabel>
                              Your subscription is set to end on{" "}
                              {renderDate(
                                source_of_truth?.subscription
                                  ?.current_period_end,
                                true
                              )}
                            </SmallLabel>
                          </Wrapper>
                        ) : null}
                      </>
                    );
                  }
                : source_of_truth?.subscription?.cancel_at_period_end
                ? () => (
                    <Wrapper>
                      <SmallLabel>
                        Your subscription is set to end on{" "}
                        {renderDate(
                          source_of_truth?.subscription?.current_period_end,
                          true
                        )}
                      </SmallLabel>
                    </Wrapper>
                  )
                : null
            }
            subtext={this.renderSubText("dealmachine")}
          >
            {!!source_of_truth?.subscription?.metadata?.main_plan_name
              ? source_of_truth?.subscription?.metadata.main_plan_name
              : "DealMachine Plan"}
          </SelectItem>
        </KeyboardView>
        {source_of_truth?.subscription?.metadata.enterprise ? (
          <BottomNavBar>
            <InlineButton
              textStyle={{ whiteSpace: "wrap" }}
              button_type={"full"}
              onPress={() => displayIntercom()}
              id="intercom_button"
            >
              To cancel your account, reach out to our support team.
            </InlineButton>
          </BottomNavBar>
        ) : !source_of_truth?.subscription?.cancel_at_period_end &&
          source_of_truth?.subscription?.billing_source !== "iap" &&
          this.props.user?.can_mimic_team_owner == 1 ? (
          <BottomNavBar>
            <ConfirmInlineButton
              textStyle={{ whiteSpace: "wrap" }}
              button_type="full"
              confirm_text="Continue with cancelation?"
              marketing_slug={"started_canceling_button"}
              onPress={() => this.startCancellationFlow()}
            >
              Cancel Plan
            </ConfirmInlineButton>
          </BottomNavBar>
        ) : source_of_truth?.subscription?.billing_source === "iap" ? (
          <BottomNavBar>
            <Wrapper style={{ textAlign: "center", padding: 20 }}>
              <Copy style={{ textAlign: "center" }}>
                Navigate to your phone's settings to manage your account.
              </Copy>
            </Wrapper>
          </BottomNavBar>
        ) : null}
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, settings, billing }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { source_of_truth } = billing;
  return {
    token,
    user,
    colors,
    source_of_truth
  };
};

export default connect(mapStateToProps, {
  getSourceOfTruth,
  popSidePanel,
  popAllSidePanels,
  manageSubscription
})(PlanDetails);
